import React, { useEffect, useState } from "react";
import NoBatchesCard from "../batchDetails/NoBatchesCard";
import TestDetailsAccordion from "./TestDetailsAccordion";
import { fetchAllPromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../common/constant";
import { useParams } from "react-router";
import CustomLoader from "../../../common/commonComponents/Loader/loader";
import AddEditResultsDialog from "./addEditResultsDialog";
import SearchResultDialog from "./SearchResultDialog";
import AButton from "../../../common/form-fields-mui/AButton";
import ALoader from "../../../common/a-loader";
import { getFormatedDate } from "../../../unAssigned/concessionApproval/common";
import { checkPermission } from "../../../common/utils/methods/commonMethods/utilityMethod";

const Results = ({ userPermissions }) => {
  const { psid } = useParams();

  const [expandedResultAccordion, setExpandedResultAccordion] = useState(false);
  const [testResults, setTestResults] = useState([]);
  const [apiLoader, setApiLoader] = useState(false);

  const [searchResultDialogOpen, setSearchResultDialogOpen] = useState(false);
  const [resultInfo, setResultInfo] = useState({}); // for storing the result fetched on the basis of rollNo
  const [addEditResultDialogOpen, setAddEditResultDialogOpen] = useState(false);

  const isUpdatePermission = checkPermission(userPermissions, 'U');
  const isCreatePermission = checkPermission(userPermissions, 'C');

  const handleResultAccordionExpansionChange =
    index => (event, newExpanded) => {
      setExpandedResultAccordion(newExpanded ? index : false);
    };

  const fetchTestResults = async () => {
    setApiLoader(true);
    try {
      const resp = await fetchAllPromisedData(
        `${endpoint.getScoreByPsidExam}?psid=${psid}`,
        true
      );
      if (resp?.code === 200) {
        setTestResults(resp?.data);
      }
      setApiLoader(false);
    } catch (err) {
      setApiLoader(false);
      console.log(err);
    }
  };

  const searchResultByRollNo = async (rollNo, action = 'add', setErrorMsg = () => { }) => {
    try {
      if (!rollNo) return;

      setApiLoader(true)
      const resp = await fetchAllPromisedData(`${endpoint?.studentResult?.getStudentResultByRollNumber}?rollNumber=${rollNo}`, true);

      const resultFound = Boolean(resp?.data?.[0]);
      if (!resultFound) setErrorMsg("Results not found for this roll no");

      if (resp?.code == 200 && resultFound) {
        const result = resp?.data?.[0];
        const resultMappedPsid = result?.emplId;

        setResultInfo({
          ...result,
          psid: resultMappedPsid,
          action,
          rollNo,
          testDate: getFormatedDate(result?.examDate),
          dateOfBirth: getFormatedDate(result?.birthdate),
        })

        if (resultMappedPsid === psid) setErrorMsg("Results already exist for this roll no");

        if (action === 'edit' || (resultMappedPsid !== psid)) {
          setAddEditResultDialogOpen(true);
        }
      }

    } catch (err) {
      console.error(err);
    } finally {
      setApiLoader(false);
    }
  }

  useEffect(() => {
    // console.log('Results mounted')
    fetchTestResults();

    return () => {
      // console.log('Results unmounted')
    };
  }, [psid]);

  return (
    <>
      {apiLoader ? (
        <ALoader />
      ) : testResults?.length ? (
        testResults?.map((el, idx) => (
          <TestDetailsAccordion
            key={idx}
            testData={el}
            idx={idx}
            expandedResultAccordion={expandedResultAccordion}
            handleChange={handleResultAccordionExpansionChange}
            searchResultByRollNo={searchResultByRollNo}
            isUpdatePermission={isUpdatePermission}
          />
        ))
      ) : (
        <NoBatchesCard message={"No Test results found for this student"} />
      )}

      <AddEditResultsDialog
        open={addEditResultDialogOpen}
        setOpen={setAddEditResultDialogOpen}
        resultInfo={resultInfo}
        setResultInfo={setResultInfo}
        fetchTestResults={fetchTestResults}
        key={addEditResultDialogOpen}
        setSearchResultDialogOpen={setSearchResultDialogOpen}
      />

      <SearchResultDialog
        open={searchResultDialogOpen}
        setOpen={setSearchResultDialogOpen}
        searchResultByRollNo={searchResultByRollNo}
        setResultInfo={setResultInfo}
        apiLoader={apiLoader}
        key={`search-${Number(searchResultDialogOpen)}`}
      />

      {isCreatePermission && <AButton
        variant="primary_filled"
        onClick={() => setSearchResultDialogOpen(true)}
        className="no-ml-btn w-25 mt-1"
      >
        Add New Result
      </AButton>
      }
    </>
  )
};

export default Results;
